import React from 'react';
import Head from 'next/head';
import amcStyles from '../../styles/amcs.scss';

interface FAQ {
  question: string;
  answer: string;
}

interface FAQsProps {
  amcFaqs: FAQ[] | null;
  expandedFaqIndex: number | null;
  toggleFAQ: (index: number) => void;
}

const FAQs: React.FC<FAQsProps> = ({
  amcFaqs,
  expandedFaqIndex,
  toggleFAQ,
}) => {
  if (!amcFaqs || !Array.isArray(amcFaqs)) {
    return <div>Loading FAQs</div>;
  }

  if (amcFaqs.length === 0) {
    return null;
  }

  const faqSchemaString = `{
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      ${amcFaqs
        .map(
          (faq: FAQ) => `{
              "@type": "Question",
              "name": "${faq.question.replace(/"/g, '\\"')}",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${faq.answer.replace(/"/g, '\\"')}"
              }
            }`
        )
        .join(',')}
    ]
  }`;

  return (
    <div>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: faqSchemaString }}
        />
      </Head>
      <div className="lil-mt-4">
        <h2 className={`${amcStyles['plan-title']} lil-pt-10 lil-pb-4`}>
          FAQs
        </h2>
        <div className="lil-rounded-xl lil-bg-white">
          {amcFaqs.map((faq: FAQ, index: number) => {
            const isExpanded = expandedFaqIndex === index;
            return (
              <div key={index} className="lil-relative">
                <div
                  className="lil-flex lil-justify-between lil-items-center lil-py-5 lil-relative"
                  onClick={() => toggleFAQ(index)}
                >
                  <span className="lil-font-semibold lil-text-s-24">
                    {faq.question}
                  </span>
                  <span>
                    {isExpanded ? (
                      <img
                        src="http://cleartax-media.s3.amazonaws.com/cleartax/images/1742892758_upchevron.svg"
                        alt="Collapse"
                      />
                    ) : (
                      <img
                        src="http://cleartax-media.s3.amazonaws.com/cleartax/images/1742892858_downchevron.svg"
                        alt="Expand"
                      />
                    )}
                  </span>
                </div>
                <div className={`lil-pb-6 ${isExpanded ? '' : 'lil-hidden'}`}>
                  <p className="lil-font-normal lil-text-s-18 lil-text-grey-600">
                    {faq.answer}
                  </p>
                </div>
                {index !== amcFaqs.length - 1 && (
                  <div className="lil-bottom-0 lil-left-0 lil-right-0 lil-absolute lil-h-px lil-bg-grey-300"></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FAQs;



// WEBPACK FOOTER //
// ./components/amcNew/FAQs.tsx